import Modal from "components/Modal";
import SMSForm from "./SMSForm";

function AuthenticationSMSModal({ open, onClose, status, onSuccess }) {
  const title = status ? "غیر فعال کردن SMS" : "فعال کردن SMS";
  return (
    <Modal dir="rtl" maxWidth="sm" title={title} open={open} onClose={onClose}>
      <SMSForm status={status} onClose={onClose} onSuccess={onSuccess} />
    </Modal>
  );
}

export default AuthenticationSMSModal;
